var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwoGearsRgbRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "dhl_icons",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44,34.3333V29.6667l-3.6054-.7211L39.51,26.81,41.5494,23.75l-3.3-3.3L35.19,22.49l-2.1359-.8846L32.3333,18H27.6667l-.7211,3.6054L24.81,22.49,21.75,20.4506l-3.3,3.3L20.49,26.81l-.8846,2.1359L16,29.6667v4.6666l3.6054.7211L20.49,37.19,18.4506,40.25l3.3,3.3L24.81,41.51l2.1359.8846L27.6667,46h4.6666l.7211-3.6054L35.19,41.51,38.25,43.5494l3.3-3.3L39.51,37.19l.8846-2.1359ZM30,36.999A4.999,4.999,0,1,1,34.999,32,4.9991,4.9991,0,0,1,30,36.999ZM27,13V11l-2.188-.7293a7.953,7.953,0,0,0-1.0654-2.5715L24.7782,5.636,23.364,4.2218,21.3008,5.2534A7.953,7.953,0,0,0,18.7293,4.188L18,2H16l-.7293,2.188a7.953,7.953,0,0,0-2.5715,1.0654L10.636,4.2218,9.2218,5.636l1.0316,2.0632A7.953,7.953,0,0,0,9.188,10.2707L7,11v2l2.188.7293a7.953,7.953,0,0,0,1.0654,2.5715L9.2218,18.364l1.4142,1.4141,2.0632-1.0315a7.9533,7.9533,0,0,0,2.5715,1.0654L16,22h2l.7293-2.188a7.9533,7.9533,0,0,0,2.5715-1.0654l2.0632,1.0315,1.4142-1.4141-1.0316-2.0632a7.953,7.953,0,0,0,1.0654-2.5715ZM17,16a4,4,0,1,1,4-4A4,4,0,0,1,17,16Z",
    fill: "#d70511"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwoGearsRgbRed);
export default __webpack_public_path__ + "static/media/two_gears_rgb_red.717b4e3d620e75174b07312973d77e80.svg";
export { ForwardRef as ReactComponent };